
import Vue from 'vue'
import Component from 'vue-class-component'
import CardTable from '../components/Layout/CardTable.vue'
import ConfirmationDialog from '@/components/Atomic/ConfirmationDialog.vue'
import GridHeader from '@/models/gridHeader'
import GuestUser, {GuestForTable} from '@/models/user'
import GuestService from '@/services/GuestService'
import ErrorHandlerService from '@/services/ErrorHandlerService'
import SearchField from '@/components/Atomic/SearchField.vue'
import ToolTipButton from '@/components/Atomic/ToolTipButton.vue'
import GuestForm from '@/components/Guests/GuestForm.vue'
import {State} from 'vuex-class'
import {User as Storeuser} from '@/store'
import {INotificationService} from '@/services/NotificationService'
import ErrorHandler from '@/services/ErrorHandlerService'
import GreenButton from "@/components/Atomic/GreenButton.vue";
import CardTitle from "@/components/Atomic/CardTitle.vue";
import RedButton from "@/components/Atomic/RedButton.vue";
import axios from "axios";
import Permissions from '../models/constants/Permissions'

@Component({
  components: {
    RedButton, CardTitle, GreenButton,
    GuestForm,
    CardTable,
    ConfirmationDialog,
    CreateGuest: GuestForm,
    SearchField,
    ToolTipButton,
  },
})
export default class Guests extends Vue {
  public $refs!: {
    confirmDeleteDialog: ConfirmationDialog,
    confirmRemoveDialog: ConfirmationDialog,
    confirmTriggerInvitationDialog: ConfirmationDialog,
    confirmSyncDialog: ConfirmationDialog,
    guestFormDialog: GuestForm,
  }
  @State private user!: Storeuser
  private errorHandlerService: ErrorHandlerService = new ErrorHandlerService()
  private $notificationService!: INotificationService
  private headers: GridHeader[] = []
  private searchString: string = ''
  private guestUsers: GuestForTable[] = []
  private isPending: boolean = false

  private async created() {
    this.createHeaders()
    await this.fetchGuests()
  }
  private async fetchGuests() {
    try {
      this.isPending = true
      this.guestUsers = []
      let guests = await GuestService.getGuests()
      guests.forEach(guest => {
        guest.guest_school.forEach( school_guest => {
            this.guestUsers.push(new GuestForTable(school_guest.id, guest.id, guest.first_name, guest.last_name, guest.email, school_guest.comment, school_guest.function, school_guest.school_id, guest.invitation_type, guest.authentication_type, guest.synchronized, school_guest.creation_date, school_guest.id))
        })
      })
    } catch (error: any) {
      this.errorHandlerService.handle(this, error.response.data.code, true)
    }
    this.isPending = false
  }

  private createHeaders() {
    this.headers.push(
        new GridHeader(this.$t('School').toString(), 'school_id', 'left', true, 100),
    )
    this.headers.push(
        new GridHeader(this.$t('FirstName').toString(), 'first_name', 'left', true, 100),
    )
    this.headers.push(
        new GridHeader(this.$t('LastName').toString(), 'last_name', 'left', true, 100),
    )
    this.headers.push(
        new GridHeader(this.$t('Email').toString(), 'email', 'left', true, 100),
    )
    this.headers.push(
        new GridHeader(this.$t('Function').toString(), 'function', 'left', true, 100),
    )
    this.headers.push(
        new GridHeader(this.$t('Comment').toString(), 'comment', 'left', true, 100),
    )
    this.headers.push(
        new GridHeader(this.$t('InvitationType').toString(), 'invitation_type', 'left', true, 100),
    )
    this.headers.push(
        new GridHeader(this.$t('AuthenticationType').toString(), 'authentication_type', 'left', true, 100),
    )
    this.headers.push(
        new GridHeader(this.$t('Synchronized').toString(), 'synchronized', 'left', true, 100),
    )
    this.headers.push(
        new GridHeader(this.$t('AddedDate').toString(), 'creation_date', 'left', true, 100),
    )
    this.headers.push(
        new GridHeader(this.$t('Actions').toString(), 'actions', 'left fixed', true, 100, 'fixed'),
    )
  }

  private get hasAccessToSynchronizeAccount(): boolean {
    const allowed = [Permissions.SynchronizeAccount]
    if (
        (this.user.permissions as []).some((permission) =>
            allowed.includes(permission),
        )
    ) {
      return true
    }
    return false
  }

  private get hasAccessToDeleteGuestAccounts(): boolean {
    const allowed = [Permissions.DeleteGuestAccounts]
    if (
        (this.user.permissions as []).some((permission) =>
            allowed.includes(permission),
        )
    ) {
      return true
    }
    return false
  }

  private showGuestForm(account = null, forCreate: boolean = true) {
    this.$refs.guestFormDialog.show(account, forCreate)
  }

  private async handleOnCloseDialog() {
    await this.fetchGuests()
  }

  private async syncGuestUser(guestId: number) {
    this.isPending = true
    try {
      await GuestService.syncAccount(guestId)
      this.$notificationService.success(this.$t('GUESTS.SyncSuccess').toString())
      await this.fetchGuests()
    } catch (error: any) {
      this.errorHandlerService.handle(this, error.response.data.code, true)
    }
    this.isPending = false
  }

  private async deleteGuestUser(guestId: number) {
    this.isPending = true
    try {
      await GuestService.delete(guestId)
      this.$notificationService.success(this.$t('GUESTS.DeletionSuccess').toString())
      await this.fetchGuests()
    } catch (error: any) {
      this.errorHandlerService.handle(this, error.response.data.code, true)
    }
    this.isPending = false
  }

  private async triggerInvitationGuestUser(guestId: number) {
    this.isPending = true
    try {
      await GuestService.triggerInvitation(guestId)
      this.$notificationService.success(this.$t('GUESTS.TriggerInvitationSuccess').toString())
      await this.fetchGuests()
    } catch (error: any) {
      this.errorHandlerService.handle(this, error.response.data.code, true)
    }
    this.isPending = false
  }

  private async removeGuestUser(guestId: number) {
    this.isPending = true
    try {
      await GuestService.removeAccount(guestId)
      this.$notificationService.success(this.$t('GUESTS.RemoveAccountSuccess').toString())
      await this.fetchGuests()
    } catch (error: any) {
      this.errorHandlerService.handle(this, error.response.data.code, true)
    }
    this.isPending = false
  }

  private getSchoolName(school_id) {
    const school = this.user.schools.find((sc) => sc.etablissement_id === school_id)
    const schoolName = school === undefined ? '' : school.nom
    return schoolName
  }
}
